import {
    Badge,
    Box,
    Button,
    ButtonGroup,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    IconButton,
    Menu,
    MenuItem,
    Slide,
    Tooltip,
    useTheme,
} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";
import {
    AddAPhoto,
    ArrowBack,
    Chat,
    FiberManualRecord,
    FullscreenExit,
    Group,
    Menu as MenuIcon,
    Mic,
    MicOff,
    Photo,
    Settings,
    Videocam,
    VideocamOff,
    Warning as WarningIcon,
} from "@material-ui/icons";
import React, { useContext, useEffect, useState } from "react";
import Fullscreen from "react-full-screen";
import { connect, ConnectedProps } from "react-redux";
import { v4 as uuid } from 'uuid';
import {
    changeLocalActiveCamera,
    changeLocalAudioInput,
    changeLocalAudioOutput,
    setAudioMuteConfirmState,
    setChangeCameraConfirmState,
    setVideoMuteConfirmState,
    toggleLocalAudio,
    toggleLocalVideo,
    sendClientAudioMuteUpdated,
} from "../../../LiveSwitch/liveSwitchActions";
import ChatSystem from "../../../Shared/Chats/ChatSystem";
import { ChatTypeSelect } from "../../../Shared/Chats/ChatTypeSelect";
import {
    ChatType,
    ParticipantStatus,
    ParticipantType,
    RecordingOption,
    Registration,
} from "../../../Shared/GeneratedTypes";
import Loading from "../../../Shared/loading";
import ObserverNotification from "../../../Shared/ObserverNotification";
import { AccessHistory, Alignment, Participant, User } from "../../../Shared/sharedTypes";
import {
    endClientSession,
    endClientSessionForLater,
    getLiveSwitchToken,
    removeClientFromSession,
    requestPhoto,
    sendChat,
} from "../../redux/actions/currentClientActions";
import "../../styles/observerIcon.css";
import "../../styles/video.css";
import { ApplicationData, ClientPhase } from "../../types";
import Photos from "./Photos/Photos";
import Video from "./Video/Video";
import Participants from "./Participants/Participants";
import HeaderIcons from "./HeaderIcons";
import { displayConnectionWarnings } from "../../../Shared/Redux/Actions/sharedActions";
import ApplicationInsightsContext from "../../../Shared/Components/ApplicationInsightsContext";
import moment from "moment";

const mapState = ({
    localizations,
    order,
    photos,
    chats,
    apiCallsInProgress,
    liveSwitchState,
    liveSwitchToken,
    deviceId,
    mentor,
    activeObservers,
    recordingState,
    onPremiseSettings,
    connectionQuality,
    registrations,
    externalObservers,
}: ApplicationData) => ({
    order,
    localizations,
    apiCallsInProgress,
    photos,
    chats,
    liveSwitchState,
    liveSwitchToken,
    deviceId,
    mentor,
    activeObservers,
    recordingState,
    onPremiseSettings,
    connectionQuality,
    registrations,
    externalObservers,
});

const mapDispatch = {
    requestPhoto,
    sendChat,
    toggleLocalVideo,
    sendClientAudioMuteUpdated,
    changeLocalActiveCamera,
    getLiveSwitchToken,
    toggleLocalAudio,
    endClientSession,
    setAudioMuteConfirmState,
    setChangeCameraConfirmState,
    setVideoMuteConfirmState,
    endClientSessionForLater,
    changeLocalAudioInput,
    changeLocalAudioOutput,
    displayConnectionWarnings,
    removeClientFromSession,
};
const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>;
type PropTypes = PropsFromRedux & {
    setFullScreen: (fullScreen: boolean) => void;
    fullScreenContainer: React.MutableRefObject<Fullscreen | null>;
    setPhase: (phase: ClientPhase) => void;
    changeLocalAudioOutput: (id: string, name: string) => void;
    displayConnectionWarnings: (value: number, consecutiveDrops: number) => void;
};

enum Section {
    video,
    chat,
    photos,
    participants,
}

function SessionTabs({
    localizations,
    order,
    photos,
    sendChat,
    requestPhoto,
    chats,
    toggleLocalVideo,
    sendClientAudioMuteUpdated,
    toggleLocalAudio,
    liveSwitchState,
    changeLocalActiveCamera,
    getLiveSwitchToken,
    liveSwitchToken,
    deviceId,
    mentor,
    setFullScreen,
    fullScreenContainer,
    endClientSession,
    setPhase,
    setAudioMuteConfirmState,
    setChangeCameraConfirmState,
    setVideoMuteConfirmState,
    endClientSessionForLater,
    changeLocalAudioInput,
    activeObservers,
    recordingState,
    changeLocalAudioOutput,
    onPremiseSettings,
    connectionQuality,
    displayConnectionWarnings,
    registrations,
    removeClientFromSession,
    externalObservers,
}: PropTypes) {
    const [currentSection, setSection] = useState(Section.video);

    const theme = useTheme();
    const [settingsMenuAnchorEl, setSettingsMenuAnchorEl] = React.useState<null | HTMLElement>(null);
    const [menuShown, setMenuShown] = useState(true);
    const [selectedMicrophone, setSelectedMicrophone] = React.useState<string>("");
    const [selectedCamera, setSelectedCamera] = React.useState<string>("");
    const [selectedSpeakers, setSelectedSpeakers] = React.useState<string>("");
    const [isRecordingAlertVisible, setRecordingAlertVisibility] = React.useState(false);
    const [chatTypesToSend, setChatTypesToSend] = React.useState<ChatTypeSelect[]>([]);
    const [participants, getParticipants] = React.useState([] as Participant[]);

    function hideRecordingAlert() {
        setRecordingAlertVisibility(false);
    }
    const appInsights = useContext(ApplicationInsightsContext);

    function showRecordingAlert() {
        setRecordingAlertVisibility(true);
    }

    const MenuGroupItem = withStyles(() => ({
        root: {
            paddingLeft: theme.spacing(3),
        },
    }))(MenuItem);

    const MenuGroupNameBase = (props: any) => <MenuItem {...props} disabled />;

    const MenuGroupName = withStyles(() => ({
        root: {
            fontWeight: theme.typography.fontWeightMedium,
            opacity: "1 !important",
            cursor: "default",
            "&:hover": {
                backgroundColor: "transparent !important",
            },
        },
    }))(MenuGroupNameBase);

    useEffect(() => {
        getLiveSwitchToken();
        getAllUsers();
    }, []);

    useEffect(() => {
        //if Safari, explicitly select first available audio device
        if (fm.liveswitch.Util.isSafari()) {
            if (liveSwitchState.localAudioInputs.length > 0) {
                var currentDevice = liveSwitchState.localAudioInputs.find((l) => l.selected == true);
                var input = currentDevice != undefined ? currentDevice : liveSwitchState.localAudioInputs[0];
                changeLocalAudioInput(input.id, input.name);
            }
        }
    }, [JSON.stringify(liveSwitchState.localAudioInputs)]);

    useEffect(() => {
        const reg = registrations?.find((x) => x.deviceId === deviceId);

        if (reg?.accessHistory?.removed?.eventDateTimeUTC != null) {
            removeClientFromSession();
            setPhase(ClientPhase.Removed);
        }

        getAllUsers();
    }, [JSON.stringify(registrations)]);

    useEffect(() => {
        getSendableChatTypes();
    }, [JSON.stringify(externalObservers), JSON.stringify(registrations)]);

    function getAllUsers() {
        let users = getParticipantsPerStatus();
        users = getAccessHistoryAndDeviceId(users);
        users = orderUsers(users);
        getParticipants(users);
    }

    function getParticipantsPerStatus(): Participant[] {
        let participants: Participant[] = [];

        let reg = getActiveRegistrations();

        for (let i = 0; i < reg.length; i++) {
            const validParticipationType = reg[i].participantType !== null;
            const uniqueParticipant = reg[i].mentorId
                ? participants.find((p) => p.id == reg[i].mentorId) === undefined
                : false;
            const uniqueExtObserver = reg[i].externalObserverSessionId
                ? participants.find((p) => p.id == reg[i].externalObserverSessionId) === undefined
                : false;
            const isSelf = reg[i].participantType == ParticipantType.Client;

            if (validParticipationType && (uniqueParticipant || uniqueExtObserver) && !isSelf) {
                let participant = {} as Participant | null;
                switch (reg[i].participantType) {
                    case ParticipantType.Mentor:
                        participant = getMentor();
                        break;
                    case ParticipantType.Client:
                        const alreadyHasMentee =
                            participants.find((p) => p.role == ParticipantType.Client) !== undefined;
                        if (alreadyHasMentee) {
                            continue;
                        }
                        participant = getMentee();
                        break;
                    case ParticipantType.Observer:
                        participant = getInternalObserver(reg[i]);
                        break;
                    case ParticipantType.ExternalObserver:
                        participant = getExternalObserver(reg[i].externalObserverSessionId!);
                        break;
                }

                if (participant !== null) {
                    participants.push(participant);
                }
            }
        }

        return participants;
    }

    function getMentor() {
        if (order?.assignedMentor === null) {
            return null;
        }

        const mentor = order.assignedMentor;

        return {
            id: mentor?.id,
            firstName: mentor?.firstName,
            lastName: mentor?.lastName,
            role: ParticipantType.Mentor,
            title: mentor?.title ?? null,
            phoneNumber: mentor?.phoneNumber ?? null,
            email: mentor?.email ?? null,
            photoUrl: mentor?.photoUrl ?? null,
            accessHistory: {} as AccessHistory,
        } as Participant;
    }

    function getMentee() {
        if (order?.contact === null) {
            return null;
        }

        const mentee = order.contact;

        return {
            id: ParticipantType.Client.toString(),
            firstName: mentee.firstName,
            lastName: mentee.lastName,
            role: ParticipantType.Client,
            title: mentee.title ?? null,
            phoneNumber: mentee.phoneNumber ?? null,
            email: mentee.email ?? null,
            photoUrl: mentee.photoUrl ?? null,
            accessHistory: {} as AccessHistory,
        } as Participant;
    }

    function getInternalObserver(reg: Registration) {
        return {
            id: reg.mentorId,
            firstName: reg.firstName,
            lastName: reg.lastName,
            title: reg.title,
            email: reg.email,
            phoneNumber: reg.phoneNumber,
            photoUrl: reg.photoUrl,
            role: ParticipantType.Observer,
            accessHistory: {} as AccessHistory,
        } as Participant;
    }

    function getExternalObserver(id: string) {
        const externalObserver = externalObservers?.find((x) => x.observerSessionId === id);
        if (!externalObserver) {
            return null;
        }

        return {
            id: id,
            firstName: externalObserver.firstName,
            lastName: externalObserver.lastName,
            title: null,
            email: externalObserver.email,
            phoneNumber: externalObserver.cellPhone,
            photoUrl: externalObserver.photoUrl,
            role: ParticipantType.ExternalObserver,
            accessHistory: {} as AccessHistory,
        } as Participant;
    }

    const RegistrationFilters = {
        isEnded: (x: Registration) => x.endUTC,
        notEnded: (x: Registration) => !x.endUTC || moment(x.lastUpdatedUTC).diff(moment(x.endUTC)) > 0,
        isWaiting: (x: Registration) => x.accessHistory?.waiting?.eventDateTimeUTC,
        isAdmitted: (x: Registration) => x.accessHistory?.admitted?.eventDateTimeUTC,
        isDenied: (x: Registration) => x.accessHistory?.denied?.eventDateTimeUTC,
        isRemoved: (x: Registration) => x.accessHistory?.removed?.eventDateTimeUTC,
        isRecent: (x: Registration) => moment.utc().diff(moment(x.lastUpdatedUTC)) < 60 * 1000 * 2,
    };

    function getActiveRegistrations(): Registration[] {
        return registrations.filter(
            (x) =>
                RegistrationFilters.notEnded(x) &&
                (!RegistrationFilters.isWaiting(x) || RegistrationFilters.isAdmitted(x)) &&
                !RegistrationFilters.isDenied(x) &&
                !RegistrationFilters.isRemoved(x)
        );
    }

    function getAccessHistoryAndDeviceId(users: Participant[]): Participant[] {
        let updatedUsers = users;

        for (let i = 0; i < updatedUsers.length; i++) {
            let allRegistrationsForUser = registrations.filter(
                (x) =>
                    (x.firstName == updatedUsers[i].firstName &&
                        x.lastName == updatedUsers[i].lastName &&
                        x.participantType == updatedUsers[i].role) ||
                    (x.mentorId !== null && x.mentorId == updatedUsers[i].id) ||
                    (x.externalObserverSessionId !== null && x.externalObserverSessionId == updatedUsers[i].id)
            );

            if (allRegistrationsForUser.length === 0) {
                continue;
            }

            updatedUsers[i].deviceId = allRegistrationsForUser[allRegistrationsForUser.length - 1].deviceId;

            if (allRegistrationsForUser.find((x) => x.accessHistory?.admitted?.eventDateTimeUTC)) {
                allRegistrationsForUser = sortRegistrationByAccessEvent(
                    allRegistrationsForUser,
                    ParticipantStatus.Active
                );
                updatedUsers[i].accessHistory.admittedUTC =
                    allRegistrationsForUser[0].accessHistory?.admitted?.eventDateTimeUTC;
                updatedUsers[i].accessHistory.admittedBy =
                    allRegistrationsForUser[0].accessHistory?.admitted?.triggeredBy;
            } else if (allRegistrationsForUser.find((x) => x.startUTC)) {
                allRegistrationsForUser.sort((a, b) => {
                    if (a.startUTC === b.startUTC) {
                        return 0;
                    } else if (!a.startUTC) {
                        return 1;
                    } else if (!b.startUTC) {
                        return -1;
                    } else {
                        return a.startUTC < b.startUTC ? 1 : -1;
                    }
                });

                const isWaiting = !!allRegistrationsForUser[0].accessHistory?.waiting?.eventDateTimeUTC;
                updatedUsers[i].accessHistory.admittedUTC = !isWaiting
                    ? allRegistrationsForUser[0].startUTC
                    : undefined;
            }

            if (allRegistrationsForUser.find((x) => x.accessHistory?.denied?.eventDateTimeUTC)) {
                allRegistrationsForUser = sortRegistrationByAccessEvent(
                    allRegistrationsForUser,
                    ParticipantStatus.Denied
                );
                updatedUsers[i].accessHistory.deniedUTC =
                    allRegistrationsForUser[0].accessHistory?.denied?.eventDateTimeUTC;
            }

            if (allRegistrationsForUser.find((x) => x.accessHistory?.removed?.eventDateTimeUTC)) {
                allRegistrationsForUser = sortRegistrationByAccessEvent(
                    allRegistrationsForUser,
                    ParticipantStatus.Removed
                );
                updatedUsers[i].accessHistory.removedUTC =
                    allRegistrationsForUser[0].accessHistory?.removed?.eventDateTimeUTC;
                updatedUsers[i].accessHistory.removedBy =
                    allRegistrationsForUser[0].accessHistory?.removed?.triggeredBy;
            }

            if (allRegistrationsForUser.find((x) => x.endUTC)) {
                allRegistrationsForUser.sort((a, b) => {
                    if (a.endUTC === b.endUTC) {
                        return 0;
                    } else if (!a.endUTC) {
                        return 1;
                    } else if (!b.endUTC) {
                        return -1;
                    } else {
                        return a.endUTC < b.endUTC ? 1 : -1;
                    }
                });

                updatedUsers[i].accessHistory.departedUTC = allRegistrationsForUser[0].endUTC;
            }
        }

        return updatedUsers;
    }

    {
        /*
     Sort to find the latest Admission, Removal, Departure, Denial easily
     */
    }
    function sortRegistrationByAccessEvent(reg: Registration[], event: ParticipantStatus): Registration[] {
        let sortedReg = reg;

        switch (event) {
            case ParticipantStatus.Active:
                sortedReg.sort((a, b) => {
                    if (a.accessHistory?.admitted?.eventDateTimeUTC === b.accessHistory?.admitted?.eventDateTimeUTC) {
                        return 0;
                    } else if (!a.accessHistory?.admitted?.eventDateTimeUTC) {
                        return 1;
                    } else if (!b.accessHistory?.admitted?.eventDateTimeUTC) {
                        return -1;
                    } else {
                        return a.accessHistory.admitted.eventDateTimeUTC < b.accessHistory.admitted.eventDateTimeUTC
                            ? 1
                            : -1;
                    }
                });
                break;
            case ParticipantStatus.Denied:
                sortedReg.sort((a, b) => {
                    if (a.accessHistory?.denied?.eventDateTimeUTC === b.accessHistory?.denied?.eventDateTimeUTC) {
                        return 0;
                    } else if (!a.accessHistory?.denied?.eventDateTimeUTC) {
                        return 1;
                    } else if (!b.accessHistory?.denied?.eventDateTimeUTC) {
                        return -1;
                    } else {
                        return a.accessHistory.denied.eventDateTimeUTC < b.accessHistory.denied.eventDateTimeUTC
                            ? 1
                            : -1;
                    }
                });
                break;
            case ParticipantStatus.Removed:
                sortedReg.sort((a, b) => {
                    if (a.accessHistory?.removed?.eventDateTimeUTC === b.accessHistory?.removed?.eventDateTimeUTC) {
                        return 0;
                    } else if (!a.accessHistory?.removed?.eventDateTimeUTC) {
                        return 1;
                    } else if (!b.accessHistory?.removed?.eventDateTimeUTC) {
                        return -1;
                    } else {
                        return a.accessHistory.removed.eventDateTimeUTC < b.accessHistory.removed.eventDateTimeUTC
                            ? 1
                            : -1;
                    }
                });
                break;
        }
        return sortedReg;
    }

    function orderUsers(users: Participant[]): Participant[] {
        const mentor = users.filter((x) => x.role === ParticipantType.Mentor);
        const mentee = users.filter((x) => x.role === ParticipantType.Client);
        const internalObservers = users.filter((x) => x.role === ParticipantType.Observer);
        const externalObservers = users.filter((x) => x.role === ParticipantType.ExternalObserver);

        return [...mentor, ...mentee, ...internalObservers, ...externalObservers];
    }

    const currentUser: User = {
        firstName: order.contact.firstName,
        lastName: order.contact.lastName,
        id: "0",
    };

    function addChatMessage(message: string, chatType: ChatTypeSelect) {
        sendChat({
            authorFirstName: order.contact.firstName,
            authorLastName: order.contact.lastName,
            authorTitle: order.contact.title,
            authorPhotoUrl: order.contact.photoUrl,
            authorType: chatType.ParticipantType,
            sentUTC: new Date(),
            chatType: chatType.ChatType,
            text: message,
            toDisplay: chatType.ToDisplay,
            toId: chatType.ToUserId,
        });
    }

    function toggleAudio() {
        sendClientAudioMuteUpdated(!liveSwitchState.audioMuted);
        toggleLocalAudio();
    }

    let settingsMenuOptions = [
        <MenuGroupName key="cams">{localizations.selectCamera}</MenuGroupName>,
        <Divider key="divCams"></Divider>,
    ]
        .concat(
            liveSwitchState.localVideoDevices.map((v) => (
                <MenuGroupItem
                    onClick={() => {
                        setSettingsMenuAnchorEl(null);
                        setSelectedCamera(v.name);
                        changeLocalActiveCamera(v.id, v.name);
                    }}
                    key={v.name}
                    selected={selectedCamera == "" ? v.selected : selectedCamera == v.name}
                >
                    {v.name}
                </MenuGroupItem>
            ))
        )
        .concat([
            <MenuGroupName key="mics">{localizations.selectMicrophone}</MenuGroupName>,
            <Divider key="divMics"></Divider>,
        ])
        .concat(
            liveSwitchState.localAudioInputs.map((v) => (
                <MenuGroupItem
                    onClick={() => {
                        setSettingsMenuAnchorEl(null);
                        setSelectedMicrophone(v.name);
                        changeLocalAudioInput(v.id, v.name);
                    }}
                    key={v.name}
                    selected={selectedMicrophone == "" ? v.selected : selectedMicrophone == v.name}
                >
                    {v.name}
                </MenuGroupItem>
            ))
        )
        .concat([
            <MenuGroupName key="speakers">{localizations.selectSpeakers}</MenuGroupName>,
            <Divider key="divSpeakers"></Divider>,
        ])
        .concat(
            liveSwitchState.localAudioOutputs.map((v) => (
                <MenuGroupItem
                    onClick={() => {
                        setSettingsMenuAnchorEl(null);
                        setSelectedSpeakers(v.name);
                        changeLocalAudioOutput(v.id, v.name);
                    }}
                    key={v.name}
                    selected={selectedSpeakers == "" ? v.selected : selectedSpeakers == v.name}
                >
                    {v.name}
                </MenuGroupItem>
            ))
        );

    const [dialogOpen, setDialogOpenState] = useState<boolean>(false);
    const [continueLaterDialogOpen, setContinueLaterDialogState] = useState<boolean>(false);

    const handleClose = () => {
        setDialogOpenState(false);
    };

    const handleContinueLaterClose = () => {
        setContinueLaterDialogState(false);
    };
    const endTheSession = () => {
        setDialogOpenState(false);
        endClientSession();
        // setPhase(ClientPhase.SessionEnded);
    };

    const endAndContinueLaterConfirmed = () => {
        setContinueLaterDialogState(false);
        endClientSessionForLater();
        setPhase(ClientPhase.SessionEndedTemporarily);
    };

    const myChats = chats.filter(
        (c) =>
            c.chatType === ChatType.Public || c.chatType === ChatType.Mentee || c.authorType === ParticipantType.Client
    );
    const recordingTooltipText = recordingState
        ? localizations.recordingOn ?? "Session is currently being recorded"
        : localizations.recordingOff ?? "Session is currently not being recorded";

    function displayNetworkQualityNotification() {
        displayConnectionWarnings(connectionQuality?.value ?? 100, connectionQuality?.consecutiveDrops ?? 0);
    }

    function getSectionTitle(section: Section) {
        let title = "";
        switch (section) {
            case Section.photos:
                title = localizations.photos;
                break;
            case Section.chat:
                title = localizations.chat;
                break;
        }
        return title;
    }

    function getSendableChatTypes() {
        let types: ChatTypeSelect[] = [];

        types.push({
            ChatType: ChatType.Public,
            ParticipantType: ParticipantType.Client,
            ToDisplay: localizations?.publicChatTypeEveryone ?? "Everyone",
        });

        types.push({
            ChatType: ChatType.Private,
            ParticipantType: ParticipantType.Client,
            ToDisplay:
                order.assignedMentor?.firstName +
                " " +
                order.assignedMentor?.lastName +
                " " +
                localizations?.mentorRole +
                " " +
                (localizations?.privateMessage ?? "(Private)"),
            ToUserId: order.assignedMentor?.id,
        });

        externalObservers?.forEach((r) => {
            const toDisplay =
                r.firstName +
                " " +
                r.lastName +
                " " +
                (localizations?.externalObserverChatType ?? "(External Observer)") +
                " " +
                (localizations?.privateMessage ?? "(Private)");

            const matchesRegistration = (reg: Registration) => reg.externalObserverSessionId === r.observerSessionId;
            const notEnded = (reg: Registration) => reg.endUTC === null;
            const inSession = (reg: Registration) =>
                reg.accessHistory?.admitted !== null && reg.accessHistory?.removed === null;

            if (
                registrations.find(
                    (reg: Registration) => matchesRegistration(reg) && notEnded(reg) && inSession(reg)
                ) &&
                !types.find((type: ChatTypeSelect) => type.ToDisplay === toDisplay)
            ) {
                types.push({
                    ChatType: ChatType.Private,
                    ParticipantType: ParticipantType.Client,
                    ToDisplay: toDisplay,
                    ToUserId: r.observerSessionId,
                });
            }
        });

        setChatTypesToSend(types);
    }

    function getSection() {
        switch (currentSection) {
            case Section.photos: {
                return <Photos photos={photos} localizations={localizations} />;
            }
            case Section.chat: {
                return (
                    <ChatSystem
                        addChat={addChatMessage}
                        canSeeChatTypes={[ChatType.Public, ChatType.Mentee]}
                        canSendChatTypes={chatTypesToSend}
                        participantType={ParticipantType.Client}
                        // setFullScreen={setFullScreen} - tried to full screen on exit for iPad but it only works on button click and is annoying
                        sessionActive={liveSwitchState.guestSessionActive}
                        chats={myChats}
                        clientLocalizations={localizations}
                        clientPaddingTop={50}
                    ></ChatSystem>
                );
            }
            case Section.participants: {
                return <Participants participants={participants} />;
            }
            case Section.video: {
                return (
                    <>
                        <Slide direction="down" in={menuShown}>
                            <div className="videoHeader header">
                                <Grid container justify="space-between">
                                    <Box clone order={{ xs: 1, sm: 2 }}>
                                        <HeaderIcons
                                            menuShown={menuShown}
                                            showRecordingAlert={showRecordingAlert}
                                            alignment={Alignment.Left}
                                        />
                                    </Box>

                                    <Box clone order={{ xs: 1, sm: 2 }}>
                                        <Grid item xs={8} sm={8}>
                                            <img src={order.logoPhotoUrl} alt="carrier logo" />

                                            <Button color="secondary" onClick={() => setContinueLaterDialogState(true)}>
                                                {localizations.endSession}
                                            </Button>
                                        </Grid>
                                    </Box>
                                </Grid>
                            </div>
                        </Slide>
                        <Slide direction="up" in={menuShown}>
                            <ButtonGroup
                                variant="text"
                                color="primary"
                                aria-label="text primary button group"
                                fullWidth={true}
                                className={"footer-slide-menu"}
                            >
                                <BigButton
                                    startIcon={liveSwitchState.videoMuted ? <VideocamOff /> : <Videocam />}
                                    onClick={toggleLocalVideo}
                                    color={liveSwitchState.videoMuted ? "secondary" : "primary"}
                                    style={{ flex: 1 }}
                                >
                                    {liveSwitchState.videoMuted
                                        ? localizations.sessionStartVideo
                                        : localizations.sessionStopVideo}
                                </BigButton>
                                <BigButton
                                    onClick={toggleAudio}
                                    startIcon={liveSwitchState.audioMuted ? <MicOff /> : <Mic />}
                                    style={{ flex: 1 }}
                                    color={liveSwitchState.audioMuted ? "secondary" : "primary"}
                                >
                                    {liveSwitchState.audioMuted
                                        ? localizations.sessionUnmute
                                        : localizations.sessionMuteMic}
                                </BigButton>
                                <Badge
                                    badgeContent={photos.length}
                                    overlap="circle"
                                    showZero
                                    color="secondary"
                                    style={{ flex: 1 }}
                                >
                                    <BigButton
                                        fullWidth
                                        onClick={() => setSection(Section.photos)}
                                        startIcon={<Photo></Photo>}
                                    >
                                        {localizations.photos}
                                    </BigButton>
                                </Badge>
                                <Badge
                                    badgeContent={myChats.length}
                                    overlap="circle"
                                    showZero
                                    color="secondary"
                                    style={{ flex: 1 }}
                                >
                                    <BigButton
                                        fullWidth
                                        onClick={() => setSection(Section.chat)}
                                        startIcon={<Chat></Chat>}
                                    >
                                        {localizations.chat}
                                    </BigButton>
                                </Badge>

                                <Badge
                                    badgeContent={participants.length}
                                    overlap="circle"
                                    showZero
                                    color="secondary"
                                    style={{ flex: 1 }}
                                >
                                    <BigButton
                                        fullWidth
                                        onClick={() => setSection(Section.participants)}
                                        startIcon={<Group />}
                                    >
                                        {localizations.participants}
                                    </BigButton>
                                </Badge>
                            </ButtonGroup>
                        </Slide>

                        <div id="controlsCurtain" className={menuShown ? "" : "slideDown"}>
                            <IconButton
                                onClick={() => setFullScreen(false)}
                                size="medium"
                                id="exitFullScreen"
                                aria-label={localizations.exitFullScreenButtonAriaLabel}
                            >
                                <FullscreenExit />
                            </IconButton>
                            <IconButton
                                onClick={() => setMenuShown(!menuShown)}
                                size="medium"
                                id="menuToggle"
                                aria-label={localizations.showMenuButtonAriaLabel}
                            >
                                <MenuIcon />
                            </IconButton>
                            <IconButton
                                onClick={() => {
                                    var uniqueId = uuid();
                                    appInsights?.trackEvent({
                                        name:
                                            "Take Photo - " +
                                            uniqueId +
                                            " requested from Client app for session: " +
                                            order.id,
                                    });
                                    !liveSwitchState.cameraBusy && requestPhoto(uniqueId, order.id);
                                }}
                                size="medium"
                                id="takePhoto"
                                aria-label={localizations.takePhotoButtonAriaLabel}
                            >
                                <AddAPhoto></AddAPhoto>
                            </IconButton>
                            <IconButton
                                aria-controls="settings-menu"
                                aria-haspopup="true"
                                id="changeSettings"
                                onClick={(e) => setSettingsMenuAnchorEl(e.currentTarget)}
                                size="medium"
                                aria-label={localizations.settingsMenuButtonAriaLabel}
                            >
                                <Settings />
                            </IconButton>
                        </div>

                        <Menu
                            id="settings-menu"
                            anchorEl={settingsMenuAnchorEl}
                            keepMounted
                            open={Boolean(settingsMenuAnchorEl)}
                            onClose={() => setSettingsMenuAnchorEl(null)}
                            container={fullScreenContainer.current!}
                        >
                            {settingsMenuOptions}
                        </Menu>

                        <Dialog
                            open={continueLaterDialogOpen}
                            onClose={handleContinueLaterClose}
                            container={fullScreenContainer.current!}
                            aria-labelledby="alert-dialog-title-continue-later"
                            aria-describedby="alert-dialog-description-continue-later"
                        >
                            <DialogTitle id="alert-dialog-title-continue-later">
                                {localizations.continueLater}?
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description-continue-later">
                                    {localizations.pleaseConfirmYouWouldLikeToClose}
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button onClick={handleContinueLaterClose} color="primary">
                                    {localizations.backToSession}
                                </Button>
                                <Button onClick={endAndContinueLaterConfirmed} color="secondary">
                                    {localizations.yesContinueLater}
                                </Button>
                            </DialogActions>
                        </Dialog>
                    </>
                );
            }
        }
    }

    if (liveSwitchToken) {
        return (
            <>
                {currentSection !== Section.video && (
                    <div className="header">
                        <Grid container>
                            <Grid item xs={2} sm={2}>
                                <IconButton
                                    onClick={() => setSection(Section.video)}
                                    style={{ backgroundColor: "#ccc", zIndex: 6 }}
                                >
                                    <ArrowBack></ArrowBack>
                                </IconButton>
                            </Grid>

                            <Grid item xs={7} sm={7}>
                                <h1 className="title"> {getSectionTitle(currentSection)}</h1>
                            </Grid>

                            <HeaderIcons
                                menuShown={menuShown}
                                showRecordingAlert={showRecordingAlert}
                                alignment={Alignment.Right}
                            />
                        </Grid>
                    </div>
                )}
                <div
                    style={{
                        position: "fixed",
                        height: "100vh",
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: theme.palette.background.paper,
                    }}
                >
                    <Video
                        sessionId={order.id}
                        menuShown={menuShown}
                        userName={order.contact.firstName}
                        visible={currentSection === Section.video}
                        liveSwitchToken={liveSwitchToken!}
                        deviceId={deviceId}
                        deviceInfo={order.clientInfo?.deviceInfo!}
                        localizations={localizations}
                        activeObservers={activeObservers}
                        recordingOption={order.sessionRecorded ?? RecordingOption.Always}
                        displayRecordingToMentee={order.product.displayRecordingToMentee === true}
                        onPremiseSettings={onPremiseSettings}
                        connectionQuality={connectionQuality}
                        isRecordingAlertVisible={isRecordingAlertVisible}
                        hideRecordingAlert={hideRecordingAlert}
                    />
                    {getSection()}

                    <Dialog
                        open={liveSwitchState.confirmAudioMute}
                        onClose={handleClose}
                        container={fullScreenContainer.current!}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{localizations.confirmAudioToggleTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {localizations.confirmAudioToggleBody}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setAudioMuteConfirmState(false);
                                    toggleAudio();
                                }}
                                color="primary"
                            >
                                {localizations.acceptButton}
                            </Button>
                            <Button onClick={() => setAudioMuteConfirmState(false)} color="secondary" autoFocus>
                                {localizations.rejectButton}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={liveSwitchState.confirmVideoMute}
                        onClose={() => setVideoMuteConfirmState(false)}
                        container={fullScreenContainer.current!}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{localizations.confirmVideoToggleTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {localizations.confirmVideoToggleBody}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    setVideoMuteConfirmState(false);
                                    toggleLocalVideo();
                                }}
                                color="primary"
                            >
                                {localizations.acceptButton}
                            </Button>
                            <Button onClick={() => setVideoMuteConfirmState(false)} color="secondary" autoFocus>
                                {localizations.rejectButton}
                            </Button>
                        </DialogActions>
                    </Dialog>

                    <Dialog
                        open={liveSwitchState.confirmCameraSelection !== null}
                        onClose={() => setChangeCameraConfirmState(null)}
                        container={fullScreenContainer.current!}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title"> {localizations.confirmCameraChangeTitle}</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {localizations.confirmCameraChangeBody1} <br />
                                <br />
                                <strong>
                                    {
                                        liveSwitchState.localVideoDevices.find(
                                            (d) => d.id === liveSwitchState.confirmCameraSelection
                                        )?.name
                                    }
                                </strong>
                                <br />
                                <br />
                                {localizations.confirmCameraChangeBody2}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                onClick={() => {
                                    var device = liveSwitchState.localVideoDevices.find(
                                        (d) => d.id === liveSwitchState.confirmCameraSelection
                                    );
                                    setChangeCameraConfirmState(null);
                                    if (device) {
                                        changeLocalActiveCamera(device.id, device.name);
                                    }
                                }}
                                color="primary"
                            >
                                {localizations.acceptButton}
                            </Button>
                            <Button onClick={() => setChangeCameraConfirmState(null)} color="secondary" autoFocus>
                                {localizations.rejectButton}
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            </>
        );
    } else {
        return <Loading message={localizations.loadingSession}></Loading>;
    }
}

export default connector(SessionTabs);

const BigButton = withStyles(() => ({
    root: {},
    label: {
        flexDirection: "column",
        fontSize: ".7em",
    },
    iconSizeMedium: {
        "& > *:first-child": { fontSize: "2em" },
    },
    startIcon: {
        margin: 0,
    },
}))(Button);
